module.exports = __webpack_public_path__ + "img/position-wrong.20e2136b.png";